import { PeriodValues } from './filterAndSortingKeys';

export const periodOptions = [
  {
    name: PeriodValues.AllTime,
    translationKey: 'x.reports.period_selector.allTime',
  },
  {
    name: PeriodValues.LastYear,
    translationKey: 'x.reports.period_selector.lastYear',
  },
  {
    name: PeriodValues.LastQuarter,
    translationKey: 'x.reports.period_selector.lastQuarter',
  },
  {
    name: PeriodValues.LastMonth,
    translationKey: 'x.reports.period_selector.lastMonth',
  },
];
